import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * Logic for Table of Contents functionality
 */

import { useEffect, useState } from 'react';
export function handleActiveTocElement(allTocElements, setActiveTocElement) {
  if (allTocElements && allTocElements.length === 0) {
    return; // to prevent error if allTocElements is undefined or empty array
  } // Set active TOC element


  allTocElements.reduce(function (activeElement, tocElement) {
    if (document.getElementById(tocElement.id)) {
      var sectionTop = document.getElementById(tocElement.id).getBoundingClientRect().top;

      if (sectionTop <= 100) {
        return setActiveTocElement(tocElement.id);
      } else {
        return activeElement;
      }
    } else {
      return activeElement;
    }
  }, {});
}
/* 🙃 The following functions are for supporting IE11 🙃 */

/* Table of Contents Support */

export function makeTocIeSticky(setIsFooterVisible, setTopOffset, setTocSticky) {
  // Set TOC to fixed when scrolling past the hero banner
  var getTopOfToc = document.getElementById('top-of-toc').offsetTop + 50;
  setTocSticky(window.pageYOffset > getTopOfToc); // Set if user hit footer

  var hitBottom = document.getElementById('footer').getBoundingClientRect().top <= window.innerHeight - 250;
  setIsFooterVisible(hitBottom); // Set offset height of footer

  var doesTocExist = document.body.contains(document.getElementById('toc-block'));

  if (!doesTocExist) {
    return;
  }

  var offSet = document.documentElement.scrollHeight - document.getElementById('footer').clientHeight - document.getElementById('toc-block').clientHeight - 1050; // specific number because of the MBP template, but remember it's only for ie11

  setTopOffset(offSet);
}
export function handleTocScroll(allTocElements, setActiveTocElement, setIsFooterVisible, setTopOffset, setTocSticky) {
  makeTocIeSticky(setIsFooterVisible, setTopOffset, setTocSticky);
  handleActiveTocElement(allTocElements, setActiveTocElement);
}
/**
 * Custom hook for handling the table of contents logic and functionality
 * @function useToc
 * @param {Array} tocElements - An array of table of content objects
 * @returns {Object} - Returns an object containing the tocState with all dependancies
 */

export function useToc(tocElements) {
  // All of this logic below is to support IE11 or any other browser that does not support `position: sticky`
  var _useState = useState(tocElements),
      _useState2 = _slicedToArray(_useState, 2),
      allTocElements = _useState2[0],
      setAllTocElements = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      isTocSticky = _useState4[0],
      setTocSticky = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      activeTocElement = _useState6[0],
      setActiveTocElement = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      isFooterVisible = _useState8[0],
      setIsFooterVisible = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      topOffset = _useState10[0],
      setTopOffset = _useState10[1];

  var shouldShowToc = tocElements && tocElements.length > 0;
  useEffect(function () {
    function handleScroll() {
      handleTocScroll(allTocElements, setActiveTocElement, setIsFooterVisible, setTopOffset, setTocSticky); // on scroll, similar as makeTocIeSticky

      handleActiveTocElement(allTocElements, setActiveTocElement); // set active TOC on scolling
    }

    setAllTocElements(tocElements); // on initial load do this, then on scroll recall similar/the same functions

    handleActiveTocElement(allTocElements, setActiveTocElement);
    makeTocIeSticky(setIsFooterVisible, setTopOffset, setTocSticky); // mainly for IE11

    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [shouldShowToc]); // eslint-disable-line

  var tocState = {
    activeTocElement: activeTocElement,
    allTocElements: allTocElements,
    isFooterVisible: isFooterVisible,
    isTocSticky: isTocSticky,
    shouldShowToc: shouldShowToc,
    topOffset: topOffset
  };
  return {
    tocState: tocState
  };
}
export default useToc;